import styled, {css} from "styled-components";

interface IVideoSlideFilterButtonBoxProps {
  isActive?: boolean;
}

export const VideoSlideFilterButtonDefaultBox = styled.div<IVideoSlideFilterButtonBoxProps>`
  user-select: none;

  border-radius: 100px;
  margin: 0px 4px;
  
  background: none;
  outline: none;

  ${({theme}) => theme.font.presets.medium};
  
  font-size: 1.4rem;

  line-height: 0.8;
  letter-spacing: 0.05em;

  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  
  height: 32px;
  width: auto;

  transition: all 0.2s ease-in-out;

  border-width: 1px;
  border-style: solid;

  color: ${props => props.theme.colors.videoSlidesFilterButtonOutline ? props.theme.colors.videoSlidesFilterButtonOutline : props.theme.colors.brandPrimary};
  border-color: ${props => props.theme.colors.videoSlidesFilterButtonOutline ? props.theme.colors.videoSlidesFilterButtonOutline : props.theme.colors.brandPrimary};

  padding: 12px;

  ${props => props.isActive ? css`
    font-weight: 600;
    border-color: ${props => props.theme.colors.brandPrimary};
    color: ${props => props.theme.colors.brandPrimary};
    background-color: ${props => `${props.theme.colors.brandPrimary}30`}; // 30 is the opacity
  ` : null}
`